import React from 'react';
import _ from 'lodash';
import { List } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import Modal from 'antd/lib/modal/Modal';
import PropTypes from 'prop-types';
import NormalButton from '../../buttons/normalButton';

import './style.scss';


const InstructionModal = (props) => {
  const onCancel = () => {
    // do something by type
    props.onCancel();
  };

  const onConfirm = () => {
    onCancel();
    props.onConfirm();
  };

  const renderInstruction = () => (
    <>
      <div className="header">
        <QuestionCircleOutlined className="icon icon-warning" />
        <div className="title">
          {props.title}
        </div>
      </div>
      <div className="body">
        <div className="description">{props.description}</div>
        {!_.isEmpty(props.esims)
        && (
          <div className="list mt-8">
            <List
              itemLayout="horizontal"
              dataSource={props.esims}
              renderItem={item => (
                <List.Item>
                  {item}
                </List.Item>
              )}
            />
          </div>
        )}
      </div>
      <div className="footer">
        <NormalButton className="mr-8" text="Cancel" onClick={onCancel} />
        <NormalButton text="OK" type="primary" onClick={onConfirm} loading={props.loading} />
      </div>
    </>
  );
  return (
    <Modal
      className="instruction-modal"
      width={420}
      visible={props.visible}
      closable={props.closable}
      maskClosable={props.maskClosable}
      footer={[]}
    >
      {renderInstruction()}
    </Modal>
  );
};

InstructionModal.defaultProps = {
  visible: false,
  loading: false,
  closable: false,
  maskClosable: false,
  isDelete: false,
  isSuccess: false,
  isWarning: false,
  isChangePassword: false,
  title: '',
  description: '',
  esims: [],

  onCancel: () => {},
  onConfirm: () => {},
};

InstructionModal.propTypes = {
  visible: PropTypes.bool,
  loading: PropTypes.bool,
  closable: PropTypes.bool,
  maskClosable: PropTypes.bool,
  isDelete: PropTypes.bool,
  isSuccess: PropTypes.bool,
  isWarning: PropTypes.bool,
  isChangePassword: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  esims: PropTypes.arrayOf(PropTypes.string),

  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default InstructionModal;
